module.exports = __webpack_public_path__ + "b34c53303a4253465812278bd026c692.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/info-sharing-center/info-sharing-center-ja.html
// module id = 943
// module chunks = 0